
export const name = 'invoice-api-config'
export const api = {
  apply: {
    save: `/api/v2/agent/agent-settlement/add`, // post
    getApplyList: `/api/v2/agent/agent-settlement/page`, // post
    getMobileApplyList: `/api/v2/agent/mobile/agent-settlement/page`, // post
    getApplyDetail: `/api/v2/agent/agent-settlement/info`, // get
    getDetails: `/api/v2/agent/invoice/details`, // get
    preview: `/api/v2/agent/proxy/invoice`, // get
    edit: `/api/v2/agent/agent-settlement/edit`, // post
    delete: `/api/v2/agent/agent-settlement/del`, // get
    batchDelete: `/api/v2/agent/agent-settlement/delBatch`, // post 批量删除
    sendEmail: `/api/v2/agent/invoice/mail`, // post 发送邮件
    createEmail: `/api/v2/agent/email-info/create`, // post 保存邮箱
    applyRedOrCancel: `/api/v2/agent/invoice/apply`, // post 提交作废/红冲申请
    taxControlInvoicing: `/api/v2/agent/settlement/handmade-invoice`, // post 税控发票开票
    allElectricInvoicing: `/api/v2/agent/allElectric/make-invoice`, // post 全电发票开票
    getAllElectricInfo: `/api/v2/agent/allElectric/taxInfo/getAvailableInfo`, // get 查询全电开票人
    getInvoiceResult: `/api/v2/agent/settlement/handmade-result`, // get
    getInvoicePage: `/api/v2/agent/invoice/page`, // post 销项发票池 分页查询
    getInvoiceInfo: `/api/v2/agent/invoice/details`, // get 查询销项发票池详情
    redInvoice: `/api/v2/agent/invoice/create-red-invoice`, // post税控红冲开票
    getInvoiceInfByCodyNo: `/api/v2/agent/red/getInvoiceByCodeNo`, // get 根据发票代码号码查询发票信息 (税控和数电)
    getInvoiceList: `/api/v2/agent/mobile/invoice/query-by-agent-settlement-id` // get 获取申请单对应的发票
  },
  statistics: {
    getStatistics: `/api/v2/agent/mobile/statistics/aggregation-statistics`, // get
    getStatsList: `/api/v2/agent/invoice/page-agent`, // POST
    getStatsMobildList: `/api/v2/agent/mobile/invoice/page`, // POST
    getStatisticsMonth: `/api/v2/agent/mobile/statistics/month` // POST
  },
  express: {
    expressTrackList: `/api/v2/agent/invoice/logisticsTraces` // post
  },
  customer: {
    getCustomersByName: `/api/v2/agent/addressee/query`, // get
    getUserDept: `/api/v2/bud/ding/dept/queryUserDept`, // get 获取部门信息
    getDefaultReceiver: `/api/v2/agent/addressee/default-info`, // get
    getReceiverList: `/api/v2/agent/addressee/page-merchantId`, // get
    getReceiverInfo: `/api/v2/agent/addressee/addressee-info`, // get
    editReceiver: `/api/v2/agent/addressee/add-update-addressee`, // post
    deleteReceiver: `/api/v2/agent/addressee/delete` // delete
  },
  goods: {
    getGoodsList: `/api/v2/agent/goods-management/page`, // get
    getGoodsInfo: `/api/v2/agent/goods-management/info/:id`, // get /:id
    addGoods: `/api/v2/agent/goods-management/add`, // post
    editGoods: `/api/v2/agent/goods-management/edit`, // post
    setDefaultGoods: `/api/v2/agent/goods/set-default`, // post 置顶商品
    getGoodsCode: `/api/v2/agent/goods/get-code`, // get
    getRevenueCodeByGoodsName: `/api/v2/agent/smart-revenue/query` // get 智能赋码接口
  },
  taker: {
    getDefaultTaker: `/api/v2/agent/proxy/last-one` // get
  },
  auditInvoicing: {
    getSelectGoods: `/api/v2/agent/auditInvoice/mobile/goodsQuery`, // GET
    saveAuditInvoiceing: `/api/v2/agent/auditInvoice/add` // POST
  },
  allElectricQrCode: {
    getQrcode: `/api/v2/agent/allElectric/authentication/getQrCode`, // GET 数电查获取认证二维码
    getAuthInfo: `/api/v2/agent/allElectric/authentication/info`, // GET 数电查询登记信息认证情况
    getAuthResult: `/api/v2/agent/allElectric/authentication/getAuthenticationResult` // POST 数电查询登记信息认证情况
  },
  allElectricLogin: {
    getAuthInfo: `/api/v2/agent/allElectric/authentication/info`, // GET 数电查询登记信息认证情况
    getMsgLoginResult: `/api/v2/agent/allElectric/authentication/autonomous/getLoginResult`, // GET 获取自主登录结果
    asyncAutonomousLogin: `/api/v2/agent/allElectric/authentication/autonomous/async/autonomousLogin`, // POST 新自主登录异步接口 发起登录
    asyncSubmitSms: `/api/v2/agent/allElectric/authentication/autonomous/async/submitSms`, // POST 自主登录异步接口 提交短信
    asyncGetQrCodeStatus: `/api/v2/agent/allElectric/authentication/autonomous/async/getQrCodeStatus` // POST 自主登录异步接口 获取二维码认证结果
  },
  blank: {
    getBlankList: `/api/v2/agent/blankInvoice/page`, // GET
    changeDevice: `/api/v2/bud/device/change-current`, // get 切盘
    queryOnLine: `/api/v2/agent/invoice/queryOnLine`, // post 查询盘的在线状态
    syncBlankInvoiceAsync: `/api/v2/agent/blankInvoice/syncBlankInvoiceAsync`, // post 同步税盘空白发票
    getClearList: `/api/v2/agent/monitoring-query-new`, // post 获取抄税清卡列表
    reportRefreshTax: `/api/v2/agent/report-refresh-tax` // post 抄税清卡
  }
}
